import {
  subLegalCollectionConfirmation,subLegalCollectionCustomConfirmation
} from '@/api/loanpost/legalCollection';
// 法务收款
import store from '@/store';
const activeTypeOption = [{
    label: '调解收款',
    value: '1',
  }, {
    label: '执行收款',
    value: '2',
  }, {
    label: '刑案收款',
    value: '3',
  }, {
    label: '法务谈判',
    value: '4',
  },{
    label: '法务结清',
    value: '5',
  },{
    label: '客户还租',
    value: '6',
  },
]
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: '主键id',
      prop: 'id',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      minWidth: 120,
      search: true,
      searchOrder: 999,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      minWidth: 100,
      type: 'input',
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      search: true,
      searchOrder: 997,
      dicData: store.getters.porductTypes,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      minWidth: 120,
      searchOrder: 998,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptList',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'input',
    },
    {
      label: '类型',
      prop: 'activeType',
      type: 'input',
      dicData: activeTypeOption
    },
  ],
};

export const operationButtonList ={
  // 调解收款
  1:{
    buttonName: '调解收款',
    dialogShow:'loanLawConfirmationVisible',
    requestFun: subLegalCollectionConfirmation,
    buttonType: 1,
  },
  // 执行收款
  2:{
    buttonName: '执行收款',
    dialogShow:'loanLawConfirmationVisible',
    requestFun: subLegalCollectionConfirmation,
    buttonType: 2,
  },
  // 刑案收款
  3:{
    buttonName: '刑案收款',
    dialogShow:'loanLawConfirmationVisible',
    requestFun: subLegalCollectionConfirmation,
    buttonType: 3,
  },
  // 法务谈判
  4:{
    buttonName: '法务结清',
    dialogShow: 'collectionConfirmationVisible',
    requestFun: subLegalCollectionConfirmation,
    buttonType: 4,
  },
  // 法务结清  无用
  // 5:{
  //   buttonName: '法务结清',
  //   dialogShow: 'collectionConfirmationVisible',
  //   requestFun: subLegalCollectionConfirmation,
  //   buttonType: 5,
  // },
  // 客户还租
  6:{
    buttonType: 6,
    buttonName: '客户还租',
    dialogShow: 'lawLoanDoRepaymentVisible',
    requestFun: subLegalCollectionCustomConfirmation,
  },
}